import React, { useState, useEffect } from 'react'

import { 
    Auth 
} from 'aws-amplify'

// Form

import { 
    useForm
} from "react-hook-form"

import {
    ErrorText
} from '../../Styles/BaseStyles'

import { 
    SectionDiv, 
    HeaderDiv, 
    FormDiv, 
    SectionHeader, 
    SettingRowDiv,
    LeftSettingDiv,
    RightSettingDiv,
    FullSettingDiv,
    SettingHeader,
    InputField,
    CancelButton,
    SaveButton,
    ConfirmationPhrase
} from  '../../Styles/Components/SettingsSectionStyles'

// Redux dispatch and selector

import { 
    useSelector,
    useDispatch
} from 'react-redux'

import {
    setUser
} from '../../Redux/Slices/UserSlice'

import {
    formatPhoneNumberAWS
} from '../../Utilities/StringTools'

function AccountSettingsSection(props){
    const dispatch = useDispatch()

    const [showActionButtons,setShowActionButtons] = useState(false)
    const [confirmUpdate,setConfirmUpdate] = useState(false)

    const user = useSelector(state => state.user.user)

    const defaults = {
        firstname: user.firstname,
        lastname: user.lastname,
        email: user.email,
        phone_number: user.phone_number
    }

    const { register, handleSubmit, watch, errors, reset } = useForm({
        defaultValues: defaults,
        validateCriteriaMode: "all",
        mode: "onChange",
    })

    const allFields = watch()

    useEffect(() => {
        if(user.firstname === allFields.firstname && user.lastname === allFields.lastname && user.email === allFields.email && user.phone_number === formatPhoneNumberAWS(allFields.phone_number)){
            reset()
            setShowActionButtons(false)
        }
        else{
            setShowActionButtons(true)
        }
    },[allFields.firstname,allFields.lastname,allFields.email,allFields.phone_number])

    useEffect(() => {
        if(confirmUpdate){
            const timeId = setTimeout(() => {
                setConfirmUpdate(false)
            }, 2000)
            return () => {
                clearTimeout(timeId)
            }
        }
        else{
            reset(defaults)
        }
    },[confirmUpdate])

    function save(data){
        var updateData = {}
        for(var key in data){
            var udKey = key
            var udData = data[key]
            if(udKey === 'phone_number'){
                udData = formatPhoneNumberAWS(udData)
            }
            if(udData !== defaults[key]){
                if(udKey === 'firstname' || udKey === 'lastname'){
                    udKey = 'custom:' + udKey
                }
                updateData[udKey] = udData
            }
        }
        Auth.currentAuthenticatedUser()
            .then(user => {
                return Auth.updateUserAttributes(user,updateData)
            })
            .then(data => {
                if(data === 'SUCCESS'){
                    Auth.currentAuthenticatedUser()
                        .then(user => {
                            dispatch(setUser({user: user}))
                        })
                    setConfirmUpdate(true)
                }
            })
            .catch(err => {
                switch(err.code){
                    default:
                        break
                }
            })
    }

    function cancel(){
        reset()
    }

    return (
        <SectionDiv id = 'user-settings-section'>
            <HeaderDiv>
                <SectionHeader>Account Information</SectionHeader>
            </HeaderDiv>
            <FormDiv>
                {!confirmUpdate &&
                    <>
                        <SettingRowDiv>
                            <LeftSettingDiv>
                                <SettingHeader>First Name:</SettingHeader>
                                <InputField 
                                    type="text" name="firstname" placeholder="First Name" 
                                    ref={
                                        register({
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            maxLength: {
                                                value: 35,
                                                message: 'exceeds 35 character limit'
                                            }, 
                                            pattern: {
                                                value: /^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð' -]+$/u,
                                                message: 'invalid character usage'
                                            }
                                        })
                                    } 
                                />
                                {errors['firstname'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['firstname']['message']}</ErrorText>}
                            </LeftSettingDiv>
                            <RightSettingDiv>
                                <SettingHeader>Last Name:</SettingHeader>
                                <InputField 
                                    type="text" name="lastname" placeholder="Last Name" 
                                    ref={
                                        register({
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            maxLength: {
                                                value: 35,
                                                message: 'exceeds 35 character limit'
                                            }, 
                                            pattern: {
                                                value: /^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð' -]+$/u,
                                                message: 'invalid character usage'
                                            }
                                        })
                                    } 
                                />
                                {errors['lastname'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['lastname']['message']}</ErrorText>}
                            </RightSettingDiv>
                        </SettingRowDiv>
                        <SettingRowDiv>
                            <LeftSettingDiv>
                                <SettingHeader>Email:</SettingHeader>
                                <InputField 
                                    type="text" name="email" placeholder="Email" 
                                    ref={
                                        register({
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            maxLength: {
                                                value: 320,
                                                message: 'exceeds 320 character limit'
                                            }, 
                                            pattern: {
                                                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                message: 'invalid format or character usage'
                                            }
                                        })
                                    } 
                                />
                                {errors['email'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['email']['message']}</ErrorText>}
                            </LeftSettingDiv>
                            <RightSettingDiv>
                                <SettingHeader>Phone Number:</SettingHeader>
                                <InputField 
                                    type="text" name="phone_number" placeholder="Phone Number" 
                                    ref={
                                        register({
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            maxLength: {
                                                value: 20,
                                                message: 'exceeds 20 character limit'
                                            },  
                                            pattern: {
                                                value: /^((\+)?\d{1,2}[-\s\.]?)?\(?\d{3}\)?[-\s\.]?\d{3}[-\s\.]?\d{4}$/,
                                                message: 'invalid format or character usage'
                                            } 
                                        })
                                    } 
                                />
                                {errors['phone_number'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['phone_number']['message']}</ErrorText>}
                            </RightSettingDiv>
                        </SettingRowDiv>
                    </>
                }
                {confirmUpdate &&
                    <>
                        <SettingRowDiv>
                            <ConfirmationPhrase>User Information Updated!</ConfirmationPhrase>
                        </SettingRowDiv>
                    </>
                }
                {showActionButtons &&
                    <SettingRowDiv>
                        <FullSettingDiv style={{'marginTop': '1rem'}}>
                            <CancelButton onClick={cancel}>Cancel</CancelButton>
                            <SaveButton onClick={handleSubmit(save)}>Save</SaveButton>
                        </FullSettingDiv>
                    </SettingRowDiv>
                }
            </FormDiv>
        </SectionDiv>
    )
}

export default AccountSettingsSection